import React from 'react';
import { Form, Card, Col, Row } from 'react-bootstrap';

import PageBar from '../../component/PageBar';
import { GetList, Update, Create, Delete, GetListDownload } from './http';
import { GetList as GetListBranch } from '../branch/http';
import download from 'downloadjs';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            newData: {
                branchId: 0,
                name: '',
                class: '',
                phone: '',
                birth: '',
                carNumber: '',
                car: '',
                account: '',
                addr: '',
                appId: '',
                appPwd: '',
            },
            search: {
                page: 1,
                size: 30,
                sort: '-id',
                status: 'OPENED',
                name: '',
            },
            branchs: [],
            totalPages: 20,
            total: 0,
        };

        const params = sessionStorage.getItem('driver_search');
        if (params) {
            this.state.search = JSON.parse(params);
        }
        this.role = localStorage.getItem('role', '');

        GetListBranch(
            this,
            {
                page: 1,
                size: 100,
                sort: 'name',
                status: 'OPENED',
                role: 'BRANCH',
            },
            res => {
                const { newData } = this.state;

                if (res.rows.length > 0) {
                    newData.branchId = res.rows[0].id;
                }
                this.setState({
                    newData,
                    branchs: res.rows,
                });
            },
        );

        this.reloadList(1);
    }

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        delete params.driverId;
        sessionStorage.setItem('driver_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    /**
     * 리스트
     */
    resultList = response => {
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
            total: response.range.total,
        });
    };

    /**
     * 등록
     * @param {*} e
     */
    clickAdd = e => {
        const { newData } = this.state;

        if (!newData.name) {
            alert('이름을 입력해주세요.');
            return;
        }

        if (!newData.appId) {
            alert('아이디를 입력해주세요.');
            return;
        }

        if (!newData.appPwd) {
            alert('패스워드를 입력해주세요.');
            return;
        }

        Create(this, newData, res => {
            alert('저장이 완료 되었습니다.');
            this.reloadList(1);
        });
    };

    /**
     * 수정
     * @param {*} item
     */
    clickSave = item => {
        if (!item.name) {
            alert('이름을 입력해주세요.');
            return;
        }

        if (!item.appId) {
            alert('아이디를 입력해주세요.');
            return;
        }

        Update(this, item.id, item, res => {
            alert('저장이 완료 되었습니다.');
            this.reloadList(this.state.search.page);
        });
    };

    /**
     * 삭제
     * @param {*} item
     */
    clickDelete = item => {
        Delete(this, item.id, res => {
            alert('삭제가 완료 되었습니다.');
            this.reloadList(this.state.search.page);
        });
    };

    /**
     * 지사 선택
     * @param {*} manager
     * @returns
     */
    selectBranch = driver => {
        const { branchs } = this.state;

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    driver.branchId = e.target.value;
                    this.setState({});
                }}
                value={driver.branchId}
            >
                {branchs.map(x => (
                    <option value={x.id} key={x.id}>
                        {x.title}
                    </option>
                ))}
            </Form.Control>
        );
    };

    render() {
        const { items, newData, branchs } = this.state;

        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                <div className="search_box_2">지사 관리</div>
                            </div>
                            <div className="rb"></div>
                        </div>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">지사 정보 입력</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>지사</th>
                                                <th>성명</th>
                                                <th>직책</th>
                                                <th>연락처</th>
                                                <th>생년월일</th>
                                                <th>차량번호</th>
                                                <th>차량종류</th>
                                                <th>자택주소</th>
                                                <th>계좌</th>
                                                <th>아이디</th>
                                                <th>비밀번호</th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>개인정보</td>
                                                <td>
                                                    {/* <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.branchId}
                                                        onChange={e => {
                                                            newData.branchId = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    /> */}
                                                    {this.selectBranch(newData)}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.name}
                                                        onChange={e => {
                                                            newData.name = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.class}
                                                        onChange={e => {
                                                            newData.class = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.phone}
                                                        onChange={e => {
                                                            newData.phone = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.birth}
                                                        onChange={e => {
                                                            newData.birth = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.carNumber}
                                                        onChange={e => {
                                                            newData.carNumber = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.car}
                                                        onChange={e => {
                                                            newData.car = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 100 }}
                                                        value={newData.addr}
                                                        onChange={e => {
                                                            newData.addr = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 100 }}
                                                        value={newData.account}
                                                        onChange={e => {
                                                            newData.account = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 100 }}
                                                        value={newData.appId}
                                                        onChange={e => {
                                                            newData.appId = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        style={{ width: 120 }}
                                                        value={newData.appPwd}
                                                        onChange={e => {
                                                            newData.appPwd = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <button type="button" className="btn_02" onClick={this.clickAdd}>
                                                        입력저장
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                {this.role === 'ADMIN' && (
                                    <div className="search_box_2">
                                        <Form.Control
                                            as="select"
                                            onChange={e => {
                                                const search = this.state.search;
                                                search.branchId = e.target.value;
                                                this.setState({ search });
                                            }}
                                            value={this.state.search.branchId}
                                        >
                                            <option value={''}>전체</option>
                                            {branchs.map(x => (
                                                <option value={x.id}>{x.title}</option>
                                            ))}
                                        </Form.Control>
                                    </div>
                                )}
                                <div className="search_box_2">
                                    <input
                                        placeholder="검색어를 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            const search = this.state.search;
                                            search.name = e.target.value;
                                            this.setState({ search });
                                        }}
                                        value={this.state.search.name}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb">
                                {/* <button title="검사원 생성하기" onClick={this.clickAdd} className="btn_02 red">
                                    <i className="feather icon-plus" /> 등록
                                </button> */}

                                <button
                                    type="button"
                                    className="btn_01 b_excel"
                                    onClick={e => {
                                        const params = this.state.search;

                                        GetListDownload(this, params, res => {
                                            download(atob(res), 'driver.xlsx', {
                                                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                            });
                                        });
                                    }}
                                >
                                    엑셀다운로드
                                </button>
                            </div>
                        </div>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">지사 리스트</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board list bg">
                                        {/* <colgroup>
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col />
                                        </colgroup> */}
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>지사</th>
                                                <th>성명</th>
                                                <th>직책</th>
                                                <th>연락처</th>
                                                <th>생년월일</th>
                                                <th>차량번호</th>
                                                <th>차량종류</th>
                                                <th>자택주소</th>
                                                <th>계좌</th>
                                                <th>아이디</th>
                                                <th>비밀번호</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((x, idx) => (
                                                <tr>
                                                    {/* <td>{x.id}</td> */}
                                                    <td>{this.state.total - this.state.search.size * (this.state.search.page - 1) - idx}</td>
                                                    <td>
                                                        {/* <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.branchId}
                                                            onChange={e => {
                                                                x.branchId = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        /> */}
                                                        {this.selectBranch(x)}
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.name}
                                                            onChange={e => {
                                                                x.name = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.class}
                                                            onChange={e => {
                                                                x.class = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.phone}
                                                            onChange={e => {
                                                                x.phone = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.birth}
                                                            onChange={e => {
                                                                x.birth = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.carNumber}
                                                            onChange={e => {
                                                                x.carNumber = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.car}
                                                            onChange={e => {
                                                                x.car = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.addr}
                                                            onChange={e => {
                                                                x.addr = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 120 }}
                                                            value={x.account}
                                                            onChange={e => {
                                                                x.account = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 100 }}
                                                            value={x.appId}
                                                            onChange={e => {
                                                                x.appId = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            style={{ width: 100 }}
                                                            value={x.appPwd}
                                                            onChange={e => {
                                                                x.appPwd = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn_02"
                                                            onClick={e => {
                                                                this.clickSave(x);
                                                            }}
                                                        >
                                                            수정저장
                                                        </button>
                                                        <div className="gab-w-40" />
                                                        <button
                                                            type="button"
                                                            className="btn_02 red"
                                                            onClick={e => {
                                                                this.clickDelete(x);
                                                            }}
                                                        >
                                                            목록 삭제
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
